/** 알림(fm 메시지) 링크·분류 */

export interface AlarmMessage {
  messageId: string;
  title?: string | null;
  body?: string | null;
  regDt?: string | null;
  readYn?: string | null;
  data?: { _link?: string | null } | null;
}

/**
 * 알림 링크를 이 앱 안의 경로로 바꾼다. 앱 안 경로가 아니면 null(새 창으로 연다).
 * 서버는 "기본 주소 + /경로" 또는 "기본 주소/#/경로" 꼴로 보낸다.
 */
export function toAppPath(link: string | null | undefined, origin: string = typeof window !== "undefined" ? window.location.origin : ""): string | null {
  if (!link) return null;
  const hash = link.indexOf("#/");
  if (hash >= 0) return link.slice(hash + 1);
  if (link.startsWith("/")) return link;
  try {
    const url = new URL(link);
    if (url.origin === origin) return url.pathname + url.search;
  } catch {
    return null;
  }
  return null;
}

export type AlarmKind = "ot" | "re100" | "etc";
export const ALARM_KIND_LABEL: Record<AlarmKind, string> = { ot: "장외거래", re100: "RE100", etc: "기타" };

/** 제목·링크로 알림 종류를 나눈다 */
export function alarmKind(m: Pick<AlarmMessage, "title" | "data">): AlarmKind {
  const link = m.data?._link ?? "";
  const title = m.title ?? "";
  if (title.includes("장외거래") || link.includes("/ot/")) return "ot";
  if (title.includes("RE100") || link.includes("/rp/")) return "re100";
  return "etc";
}
